import { render, staticRenderFns } from "./OneTimeOrder.vue?vue&type=template&id=dbbf8e56&scoped=true&"
import script from "./OneTimeOrder.vue?vue&type=script&lang=js&"
export * from "./OneTimeOrder.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeOrder.vue?vue&type=style&index=0&id=dbbf8e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf8e56",
  null
  
)

export default component.exports